import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg viewBox='0 0 10 10' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.88496 5.62142C4.14984 5.72798 4.36032 5.9294 4.47739 6.18819C4.75883 6.81234 5.30159 8.02668 5.63742 8.83116C5.73794 9.07122 6.08678 9.05014 6.15773 8.80071L7.98942 2.34728C8.04855 2.13767 7.84989 1.9468 7.64058 2.01354L1.1924 4.0511C0.942892 4.12956 0.933432 4.47618 1.17939 4.56634C2.0036 4.87081 3.24759 5.36614 3.88732 5.62142H3.88496Z'
      fill='currentColor'
    />
  </svg>,
  'MmmArrow',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
